import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import {
  Trans,
} from "gatsby-plugin-react-i18next"
import * as sectionStyle from "../section.module.css"
import * as Style from "./partners.module.css"

export function Partnerts(props) {
  return (
    <div className={`${sectionStyle.section} ${Style.partner}`}>
      <div className={sectionStyle.sectionHeader}>
        <Trans>visionaries</Trans>
      </div>
      <div className={Style.logo}>
        <div className={Style.logoItem}>
          <StaticImage
            className={Style.staticImage}
            src="./wanxiang.svg"
            placeholder="blur"
            alt="Ant OC Logo"
            objectFit="contain"
          />
          {/* <StaticImage
            className={Style.staticImage}
            src="../../../images/partners/wanxiang.png"
          ></StaticImage> */}
        </div>
        <div className={Style.logoItem}>
          <StaticImage
            className={Style.staticImage}
            src="../../../images/partners/yifangda@2x.png"
          ></StaticImage>
        </div>
        <div className={Style.logoItem}>
          <StaticImage
            className={Style.staticImage}
            src="../../../images/partners/order@2x.png"
          ></StaticImage>
        </div>
        <div className={Style.logoItem}>
          <StaticImage
            className={Style.staticImage}
            src="../../../images/partners/antGroup@2x.png"
          ></StaticImage>
        </div>
        <div className={Style.logoItem}>
          <StaticImage
            className={Style.staticImage}
            src="../../../images/partners/InvestemtGroup@2x.png"
          ></StaticImage>
        </div>
      </div>
    </div>
  )
}
